import { createSlice } from '@reduxjs/toolkit'
import { getMetalDoors, saveMetalDoor, createMetalDoor, deleteMetalDoor } from './metalDoorActions'

const initialState = {
  metalDoors: [],
  loading: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedMetalDoor: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

const metalDoorSlice = createSlice({
  name: 'metalDoors',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedMetalDoor = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getMetalDoors.fulfilled, (state, { payload }) => {
        state.loading = false
        state.metalDoors = payload
        /*payload.forEach((i) => {
          state.metalDoors[i.id] = i
        })*/
      })
      .addCase(getMetalDoors.pending, (state) => {
        state.loading = true
        state.loadingError = null
        state.savingError = null
      })
      .addCase(getMetalDoors.rejected, (state, { payload }) => {
        state.loading = false
        state.loadingError = payload
      })
      .addCase(saveMetalDoor.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveMetalDoor.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedMetalDoor = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveMetalDoor.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createMetalDoor.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createMetalDoor.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedMetalDoor = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createMetalDoor.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteMetalDoor.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteMetalDoor.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteMetalDoor.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
    /*.addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )*/
  },
})

export const { clear } = metalDoorSlice.actions
export default metalDoorSlice.reducer
